/**
 * @generated SignedSource<<57b0aa7048465e047f9107e05f14395c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PGAnalyzeIntegrationQuery$variables = Record<PropertyKey, never>;
export type PGAnalyzeIntegrationQuery$data = {
  readonly me: {
    readonly organization: {
      readonly integrations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly credentials: any;
            readonly id: any;
          };
        }>;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"appMe">;
  };
};
export type PGAnalyzeIntegrationQuery = {
  response: PGAnalyzeIntegrationQuery$data;
  variables: PGAnalyzeIntegrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "integrationType",
      "value": "PGANALYZE"
    }
  ],
  "concreteType": "GraphQLIntegrationConnection",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "credentials",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "integrations(integrationType:\"PGANALYZE\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAnalyzeIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appMe"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAnalyzeIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pictureUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuperAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandTheme",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSuspended",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspensionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspendedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creditLimitResetAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appUrlDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledFeatureFlags",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLUserTeamContext",
            "kind": "LinkedField",
            "name": "teamContext",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLTeam",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75542981858cd95f92c02576854ba1b9",
    "id": null,
    "metadata": {},
    "name": "PGAnalyzeIntegrationQuery",
    "operationKind": "query",
    "text": "query PGAnalyzeIntegrationQuery {\n  me {\n    ...appMe\n    organization {\n      integrations(integrationType: PGANALYZE) {\n        edges {\n          node {\n            id\n            credentials\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment appMe on GraphQLUser {\n  id\n  email\n  firstName\n  lastName\n  pictureUrl\n  isSuperAdmin\n  role\n  scopes\n  organization {\n    id\n    name\n    brandTheme\n    isSuspended\n    suspensionReason\n    suspendedAt\n    creditLimitResetAt\n    appUrlDomain\n    onboardingCompletedAt\n    enabledFeatureFlags\n  }\n  teamContext {\n    id\n    team {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aad2a433a51c0d037c91ea0de2d99963";

export default node;
